// extracted by mini-css-extract-plugin
module.exports = {"header":"linkReg_header__29AfS","importRegCard":"linkReg_importRegCard__1S7-q","dropLabel":"linkReg_dropLabel__34tos"};